import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import GeneralLayout from '@core/layouts/GeneralLayout';
import { ROUTES } from '@core/utils/constants';
import { devMode } from '@core/utils/misc';

const DesignSystem = lazy(() => import('@core/pages/DesignSystem'));
const NotFound = lazy(() => import('@core/pages/NotFound'));
const ConnectionError = lazy(() => import('@core/pages/ConnectionError'));

const CoreRouter: RouteObject = {
  element: <GeneralLayout />,
  children: [
    ...(devMode
      ? [
          {
            path: ROUTES.general.designSystem,
            element: <DesignSystem />,
          },
        ]
      : []),
    { path: ROUTES.general.connection, element: <ConnectionError /> },
    { path: ROUTES.general.notFound, element: <NotFound /> },
  ],
};

export default CoreRouter;
